/**
 * Chuỗi của nhóm màn `hoi` (Hỏi đáp AI, Trò chuyện với bot) thuộc module `tro-ly-ai` — tạm tách tệp khi dựng song
 * song, sẽ gộp vào `vi.ts`. Khoá cấp một mang tiền tố `troLyAiHoi`; sâu tối đa hai cấp dưới nó.
 */
export const viHoi = {
  troLyAiHoi: {
    tieuDe: 'Hỏi đáp AI',
    moTa: 'Câu hỏi được mô hình chuyển thành câu lệnh SQL. Câu lệnh phải qua lớp kiểm soát truy vấn của nền tảng (chỉ cho phép SELECT, giới hạn số dòng trả về, dùng tài khoản chỉ đọc) rồi mới chạy trên bản sao dữ liệu. Câu trả lời luôn kèm câu lệnh đã chạy, số dòng và thời điểm cập nhật dữ liệu.',
    phuDe: 'Hỏi bằng tiếng Việt trên bản sao dữ liệu — câu trả lời kèm câu lệnh SQL và thời điểm cập nhật dữ liệu.',
    doanHoiMoi: 'Đoạn chat mới',
    doanHoiMacDinh: 'Đoạn chat mới',
    chuaCoDoan: 'Chưa có đoạn chat nào. Đoạn chat được lưu tự động khi bạn gửi câu hỏi đầu tiên.',
    lichSuTheoNguon: 'Lịch sử được lưu riêng theo nguồn dữ liệu và theo quyền của bạn. Một đoạn chat hiện ở mọi lựa chọn nguồn có chứa nguồn của nó.',
    doiNguonDongDoan: 'Đã mở đoạn chat mới vì đoạn cũ thuộc lựa chọn nguồn trước đó. Mở lại đoạn cũ từ danh sách sẽ khôi phục đúng lựa chọn nguồn ấy.',
    nhieuNguonChuaSanSang: '{{n}} nguồn chưa sẵn sàng',
    xoaDoanHoi: 'Xoá đoạn chat {{ten}}',
    xacNhanXoaTieuDe: 'Xoá đoạn chat «{{ten}}»?',
    xacNhanXoaNoiDung: 'Đoạn chat và mọi lượt hỏi trong đó sẽ bị xoá. Không hoàn tác được.',
    xoaDoanNut: 'Xoá đoạn chat',
    oSoanPlaceholder: 'Hỏi về dữ liệu — nên nêu rõ kỳ (tháng, quý, năm) trong câu hỏi',
    cauHoi: 'Câu hỏi',
    guiCauHoi: 'Gửi câu hỏi',
    nguonChuaSanSang: 'Nguồn chưa sẵn sàng',
    chuaSanSang: '{{ten}} — chưa sẵn sàng',
    llmOff: 'Chưa gọi được mô hình ({{model}}). Bạn vẫn có thể tự viết SQL và chạy ở màn Thử nghiệm — việc kiểm soát truy vấn, bản sao dữ liệu và thời điểm cập nhật dữ liệu không phụ thuộc vào mô hình.',
    enterDeGui: 'Enter để gửi · Shift+Enter xuống dòng · lượt hỏi được lưu theo nguồn',
    loiNguonTieuDe: 'Không đọc được danh sách nguồn',
    loiNguonGoiY: 'Nếu bạn đăng nhập trước lần cấp quyền gần nhất thì phiên đăng nhập chưa nhận quyền mới — hãy đăng xuất rồi đăng nhập lại.',
    chuaChonNguon: 'Chưa chọn nguồn dữ liệu nên chưa gửi được câu hỏi.',
    goiYChuaCo: 'Chưa có câu hỏi gợi ý cho nguồn này.',
    chuaCoNguon: 'Chưa có nguồn dữ liệu nào. Thêm một nguồn ở màn Kết nối nguồn để bắt đầu hỏi.',
    ganDay: 'Gần đây',
    danhSachDoan: 'Danh sách đoạn chat',
    nguonDuLieu: 'Nguồn dữ liệu cho câu hỏi',
    tuyChonTraLoi: 'Tuỳ chọn trả lời',
    moHinh: 'Mô hình',
    khongTaiDuocMoHinh: 'Không tải được danh sách mô hình',
    chuaCauHinh: 'chưa cấu hình',
    hoiBangGiongNoi: 'Hỏi bằng giọng nói',
    dangNghe: 'Đang nghe — bấm để dừng',
    dungNghe: 'Dừng nghe',
    dung: 'Dừng',
    enterDeGuiNgan: 'Enter để gửi · Shift+Enter xuống dòng',
    daLuuLuot: 'lượt đã lưu',
  },
  troLyAiHoiLuot: {
    tieuDeNhan: 'Nhãn khai báo',
    tieuDeTenCot: 'Tên cột',
    kieuTieuDe: 'Tiêu đề cột',
    khaiCotNay: '→ Khai báo cột {{cot}}',
    khongTraLoiDuoc: 'Không trả lời được',
    chiTietKyThuat: 'Chi tiết kỹ thuật (dành cho quản trị)',
    thuHoi: 'Thử hỏi',
    hoiTiep: 'Hỏi tiếp',
    chonMotCauCuThe: 'Chọn một câu cụ thể',
    canLamRo: 'Cần làm rõ thêm',
    quaTranDam: 'Đã bỏ phần diễn giải',
    quaTranMo: 'vì vượt quá thời gian cho phép — bảng bên dưới vẫn là kết quả đầy đủ và đã qua mọi bước kiểm tra.',
    quaTranBotMo: 'vì vượt quá thời gian cho phép — kết quả vẫn đầy đủ và đã qua mọi bước kiểm tra.',
    nguonGocSo: 'Nguồn gốc con số',
    soTinhRa: 'Tính ra từ bảng',
    deXuat: 'Phương án đề xuất — suy luận của trợ lý, không phải số liệu',
    taiLieuDaDan: 'Tài liệu đã dẫn · {{n}} đoạn',
    doan: 'đoạn {{n}}',
    dangDocThanhTieng: 'Đang tổng hợp giọng đọc...',
    chuAnViGiongNoi: 'Bot này dùng kênh Giọng nói — câu trả lời được phát bằng giọng đọc, không hiển thị chữ.',
    docHongHienChu: 'Không tổng hợp được giọng đọc đầy đủ nên hiển thị chữ để bạn không bỏ lỡ câu trả lời.',
    dong: '{{n}} dòng',
    daCatBot: 'đã cắt bớt',
    soLieuToi: 'dữ liệu cập nhật đến {{luc}}',
    soLieuTrucTiep: 'số liệu trực tiếp',
    khongTraONguon: 'Không tra ở {{n}} nguồn',
    soLieuDaCat: 'Đã lưu {{luu}}/{{tong}} dòng — biểu đồ không được vẽ lại khi số liệu không đầy đủ.',
    luotNhieuNguon: 'Lượt này hỏi trên nhiều nguồn: {{ds}}. Bảng trên thuộc nguồn đầu tiên — bảng của các nguồn còn lại không được lưu.',
    nguonTomTat: '{{ten}} ({{chiTiet}})',
    phanTrang: '{{dau}}–{{cuoi}} / {{tong}} dòng',
    bangKetQua: 'Bảng kết quả',
    hetGio: 'Lượt hỏi chạy quá 120 giây nên đã dừng. Thử hỏi hẹp hơn (một kỳ, một nhóm) rồi hỏi lại.',
  },
  troLyAiHoiTienTrinh: {
    dangBatDau: 'Đang bắt đầu...',
    xemTienTrinh: 'Xem tiến trình · {{n}} bước',
    anTienTrinh: 'Ẩn tiến trình · {{n}} bước',
    daVietLai: 'Hệ thống đã tự rà soát và viết lại câu truy vấn {{n}} lần; bản cuối đã qua kiểm tra an toàn trước khi chạy.',
    soKhongNguon: '{{n}} con số trong câu trả lời chưa truy được nguồn (ô số liệu hoặc đoạn tài liệu): {{ds}} — hãy đối chiếu với phần số liệu và tài liệu bên dưới.',
    cauVuotBang: '{{n}} câu nhận định về toàn bộ bảng nhưng chỉ dựa trên các dòng đầu: {{ds}}',
    thoiGianChang: 'Thời gian từng bước',
    chongLan: 'Bước này chạy song song với các bước khác có dấu ∥ — không cộng dồn thời gian của chúng.',
    mauDau: 'token đầu sau {{ms}} ms',
    loiGoiMoHinh: '{{n}} lời gọi mô hình',
    khaiCotNay: '→ Khai báo cột {{cot}}',
    token: '{{vao}} vào · {{ra}} ra',
    dem: '· đệm {{pt}}%',
  },
  troLyAiHoiKichBan: {
    tienDo: 'Tiến độ kịch bản {{ten}}',
    daXong: 'Đã xong',
    buoc: 'Bước {{i}}/{{n}}',
    conThieu: 'Còn thiếu:',
  },
  troLyAiHoiGiong: {
    chuaCoGiong: 'Máy chủ chưa có giọng đọc nào.',
    chuaCoGiongMo: 'Cần cấu hình giọng đọc cho tầng hỏi–đáp trên máy chủ — không phải trên máy này.',
    giongDoc: 'Giọng đọc',
    batDoc: 'Đọc câu trả lời thành tiếng',
    tatDoc: 'Tắt đọc thành tiếng',
    tamDung: 'Tạm dừng đọc',
    tiepTuc: 'Nghe tiếp',
  },
  troLyAiHoiBot: {
    tieuDe: 'Chatbot AI',
    phuDe: 'Đặt câu hỏi bằng tiếng Việt; câu trả lời dựa trên các nguồn dữ liệu và tài liệu được cấp cho chatbot này.',
    khongCoBot: 'Không có chatbot nào mang mã {{id}}, hoặc bạn chưa được cấp quyền dùng nó. Có thể nó vừa bị xoá.',
    veLuoiBot: 'Về danh sách bot',
    doanChatMoi: 'Đoạn chat mới',
    tatLuuLichSu: 'Bot này đang tắt lưu lịch sử nên không có đoạn chat nào được lưu. Bật ở màn Cấu hình chatbot nếu muốn xem lại.',
    chuaCoDoanChat: 'Chưa có đoạn chat nào.',
    doanTheoQuyen: 'Đoạn chat riêng theo quyền của bạn.',
    xoaDoanChat: 'Xoá đoạn chat {{ten}}',
    botVanBan: 'Chỉ văn bản',
    botVanBanGhi: 'Bot này đặt kênh giao tiếp là “Văn bản” nên không đọc thành tiếng. Đổi ở màn Cấu hình chatbot.',
    botDangTat: 'Bot đang tắt',
    botDangTatGhi: 'Bot đang tắt — câu hỏi vẫn chạy được ở đây để thử nghiệm, nhưng người dùng chưa thể tương tác.',
    moBotLai: 'Bot này đang tắt. Bật ở màn Cấu hình chatbot để mở lại cho người dùng.',
    hoiMotCau: 'Hỏi một câu để bắt đầu cuộc trò chuyện.',
    nhieuNguon: '{{n}} nguồn',
    nhieuNguonGhi: 'Mỗi câu hỏi được tra riêng trên từng nguồn đã gắn; câu trả lời ghi rõ con số nào thuộc nguồn nào.',
    thieuApiKey: 'Chưa cấu hình API Key cho mô hình AI ({{model}}).',
    hoiBot: 'Hỏi {{ten}}...',
    botMacDinh: 'bot',
    modeKnowledgeOnly: 'Chỉ trả lời trong phạm vi tài liệu',
    modeOpen: 'Được trả lời ngoài phạm vi',
    tatCaBot: 'Tất cả bot',
  },
  troLyAiHoiTuyChon: {
    tangTraLoi: 'Mức phân tích',
    tangTraLoiGhi: 'Nội dung phần diễn giải quanh số liệu. Bảng chỉ hiện khi phần diễn giải không trình bày hết được.',
    doDai: 'Độ dài câu trả lời',
    doDaiGhi: 'Số lượng chữ. Khác với mức phân tích ở trên — mức phân tích quyết định nội dung được viết.',
    bieuDo: 'Biểu đồ',
    traWeb: 'Tra trên web',
    traWebNgan: 'Tra web',
    traWebNhan: 'Tra trên web: {{bac}}',
  },
  troLyAiHoiDoDai: {
    ngan: { nhan: 'Ngắn', mo: 'Một đoạn — kết luận và con số, không hơn.' },
    vua: { nhan: 'Vừa', mo: 'Ba đoạn ngắn. Đủ cho khoảng, tỉ trọng và một điểm đáng chú ý.' },
    chi_tiet: { nhan: 'Chi tiết', mo: 'Bốn đoạn, câu dài hơn. Có chỗ cho phân bố và so sánh.' },
    day_du: { nhan: 'Đầy đủ', mo: 'Sáu đoạn. Chậm hơn 1–2 giây vì phải viết nhiều hơn.' },
  },
  troLyAiHoiCapVan: {
    gon: { nhan: 'Gọn', mo: 'Chỉ kết luận và con số cốt lõi' },
    phan_tich: { nhan: 'Phân tích', mo: 'Thêm khoảng, tỉ trọng, điểm bất thường' },
    khuyen_nghi: { nhan: 'Khuyến nghị', mo: 'Thêm phạm vi và bước tiếp theo' },
  },
  troLyAiHoiChonWeb: {
    khong: { nhan: 'Không tra', mo: 'Bỏ qua web hoàn toàn — trả lời nhanh nhất' },
    tu_dong: { nhan: 'Tự động', mo: 'Chỉ tra khi số liệu và tài liệu không có kết quả — chậm thêm 6–7 giây khi tra' },
    chi_web: { nhan: 'Chỉ tra web', mo: 'Bỏ qua số liệu và tài liệu, chỉ dùng các trang đã khai báo' },
  },
  troLyAiHoiChonBieuDo: {
    tu_dong: { nhan: 'Tự động', mo: 'Vẽ khi câu hỏi yêu cầu — “vẽ biểu đồ”, “đồ thị”...' },
    co: { nhan: 'Luôn vẽ', mo: 'Vẽ ở mọi lượt, nếu dữ liệu phù hợp với một dạng biểu đồ' },
    khong: { nhan: 'Không vẽ', mo: 'Không vẽ, kể cả khi câu hỏi yêu cầu' },
  },
  troLyAiHoiKenh: {
    van_ban: 'Chỉ văn bản',
    giong_noi: 'Giọng nói',
    ca_hai: 'Giọng nói + văn bản',
  },
  troLyAiHoiLuoiBot: {
    tieuDe: 'Trò chuyện với bot',
    phuDe: 'Chọn một bot để bắt đầu trò chuyện. Mỗi bot trả lời trong phạm vi tài liệu và dữ liệu đã gắn cho nó.',
    timBot: 'Tìm bot theo tên hoặc mô tả',
    demBot: '{{shown}}/{{total}} bot',
    demNguon: '{{n}} nguồn',
    rongTieuDe: 'Chưa có bot nào dùng được',
    rongMoTa: 'Bạn chưa được cấp quyền dùng bot nào. Liên hệ quản trị để được cấp quyền.',
    rongMoTaQuanTri: 'Chưa có bot nào đang bật và có nguồn để trả lời. Tạo hoặc bật bot ở Cấu hình chatbot.',
    sangCauHinh: 'Sang Cấu hình chatbot',
    khongKhopTieuDe: 'Không bot nào khớp',
    danhSachBot: 'Danh sách bot',
  },
  troLyAiHoiBieuDo: {
    tieuDe: 'Biểu đồ',
    an: 'Ẩn',
    hien: 'Hiện',
    doiDang: 'Đổi dạng biểu đồ',
    ty: 'tỷ',
    trieu: 'tr',
    nghin: 'ng',
    dongPhanPhoi: '{{tu}} – {{den}}: {{n}} dòng',
    soVoiBuocDau: '{{pt}}% so với bước đầu',
    cot: 'Cột',
    cot_ngang: 'Cột ngang',
    cot_nhom: 'Cột nhóm',
    cot_chong: 'Cột chồng',
    cot_chong_100: 'Cột chồng 100%',
    duong: 'Đường',
    duong_nhieu: 'Nhiều đường',
    vung: 'Vùng',
    tron: 'Tròn',
    vanh: 'Vành khuyên',
    phan_tan: 'Phân tán',
    bong_bong: 'Bong bóng',
    nhiet: 'Nhiệt đồ',
    phan_phoi: 'Phân phối',
    thac: 'Thác',
    phieu: 'Phễu',
    radar: 'Radar',
    so_lon: 'Một con số',
  },
} as const;
